import { render, staticRenderFns } from "./photoForm.vue?vue&type=template&id=83f32d24&"
import script from "./photoForm.vue?vue&type=script&lang=js&"
export * from "./photoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports